<template>
    <portal to="modal">
        <div class="modal-wrapper" v-if="opened || keep" v-show="opened">
            <div class="modal-backdrop" @click="close"></div>

            <div class="modal">
                <button type="button" class="modal-close" @click="close" />
                <div class="modal-content">
                    <slot />
                </div>
            </div>
        </div>
    </portal>
</template>

<script>
import {mapActions} from "vuex";

export default {
    props: {
        opened: Boolean,
        keep: {
            type: Boolean,
            default: () => false,
        },
    },
    mounted() {
        this.setHtmlScroll(!this.opened);
    },
    watch: {
        opened(val) {
            if (val) {
                this.setHtmlScroll(false);
            }
        },
    },
    methods: {
        ...mapActions([
            'setHtmlScroll',
        ]),
        close() {
            if (!this.opened) {
                return;
            }

            this.$emit('close');
            this.setHtmlScroll(true);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";
@import '~@/styles/variables';

.modal-wrapper {
    position: fixed;
    z-index: 99999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    @include on-desktop {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }
}

.modal-backdrop {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(42, 38, 38, 0.50);
}

.modal {
    position: relative;
    box-sizing: border-box;
    z-index: 1;
    background: #fff;
    padding: 0;
    border-radius: rem(0);

    @include on-desktop {
        padding: rem(40);
        border-radius: rem(16);
    }

    .modal-content {
        overflow-x: hidden;
        overflow-y: auto;
        margin: 0;
        height: 100vh;
        padding: mrem(40);

        @include on-desktop {
            height: auto;
            padding: 0 rem(40);
            margin: 0 rem(-40);
            max-height: calc(100vh - #{rem(140)});
        }
    }
}

.modal-close {
    position: absolute;
    border: none;
    background: #fff url("~@/assets/images/close-circle-black.svg") no-repeat center center;
    background-size: cover;
    cursor: pointer;
    top: mrem(16);
    right: mrem(16);
    width: mrem(24);
    height: mrem(24);

    @include on-desktop {
        top: rem(16);
        right: rem(16);
        width: rem(24);
        height: rem(24);
    }

}

</style>
